import { render, staticRenderFns } from "./ToggleSwitchEditElement.vue?vue&type=template&id=ca96490c&scoped=true"
import script from "./ToggleSwitchEditElement.vue?vue&type=script&lang=js"
export * from "./ToggleSwitchEditElement.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitchEditElement.vue?vue&type=style&index=0&id=ca96490c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca96490c",
  null
  
)

export default component.exports